import { render, staticRenderFns } from "./events_block.vue?vue&type=template&id=36599f5b"
import script from "./events_block.vue?vue&type=script&lang=js"
export * from "./events_block.vue?vue&type=script&lang=js"
import style0 from "./events_block.vue?vue&type=style&index=0&id=36599f5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports